import { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { ContactFilter } from "../../../../Constants/Constants";
import { LeftContactAsideProps } from "../../../../Types/ContactType";
import { ProfileHeader } from "./Common/ProfileHeader";
import { ContactNav } from "./ContactNav";

export const LeftContactAside:React.FC<LeftContactAsideProps> = ({ activeTab, setActiveTab, changeTab }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Col xl="3" className="box-col-6">
      <div className="md-sidebar">
        <Btn color="primary" className="md-sidebar-toggle" onClick={() => setIsOpen(!isOpen)}>
          {ContactFilter}
        </Btn>
        <div className={`md-sidebar-aside job-left-aside custom-scrollbar ${isOpen ? "open" : ""}`}>
          <div className="email-left-aside">
            <Card>
              <CardBody>
                <div className="email-app-sidebar left-bookmark">
                  <ProfileHeader />
                  <ContactNav activeTab={activeTab} setActiveTab={setActiveTab} changeTab={changeTab} />
                </div>
              </CardBody>
            </Card>
          </div>
        </div>
      </div>
    </Col>
  );
};
